import {
  TRIP_ACTIVE_LOADING,
  TRIP_ACTIVE_ERROR,

  TRIP_ACTIVE_LIST,
  TRIP_ACTIVE_FILTERS,
  TRIP_ACTIVE_FINISH
} from "actions/trip-active/constants";

const initialState = {
  loading: false,
  errors: [],

  list: [],
  filters: [],
};

export default function(state = initialState, action) {
  switch (action.type) {
    case TRIP_ACTIVE_LOADING:
      return {
        ...state,
        loading: action.payload.content
      };
    case TRIP_ACTIVE_ERROR:
      return {
        ...state,
        loading: false,
        errors: action.payload.content
      };
    case TRIP_ACTIVE_LIST:
      return {
        ...state,
        loading: false,
        errors: [],
        list: action.payload,
      };
    case TRIP_ACTIVE_FILTERS:
      return {
        ...state,
        loading: false,
        errors: [],
        filters: action.payload.content,
      };
    case TRIP_ACTIVE_FINISH:
      return {
        ...state,
        list: {
          ...state.list,
          content: (state.list.content || []).filter(item => item.id !== action.payload)
        }
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/tripActiveReducer.js